import { render, staticRenderFns } from "./SafeGaurdTermsSKT.vue?vue&type=template&id=65aff8ec&scoped=true&"
import script from "./SafeGaurdTermsSKT.vue?vue&type=script&lang=js&"
export * from "./SafeGaurdTermsSKT.vue?vue&type=script&lang=js&"
import style0 from "./SafeGaurdTermsSKT.vue?vue&type=style&index=0&id=65aff8ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aff8ec",
  null
  
)

export default component.exports